import { styled } from '@mui/material/styles';
import { Fab } from '@mui/material';

export const StyledFab = styled(Fab)(() => ({
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 1000,
}));
